import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import { PrintOutlined } from '@mui/icons-material'
import { getCurrentDate } from 'utils/helpers'

export const getColumns = (printNotice) => [
  {
    title: 'Magazin',
    field: 'shopCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Furnizor',
    field: 'supplierName',
    align: 'left',
    type: 'string',
    render: row => `${row.supplierName} (${row?.supplierCode})`
  },
  {
    title: 'Societate',
    field: 'parentSociety',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Numar inmatriculare',
    field: 'truckNumber',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Nume sofer',
    field: 'driverName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Avize magazin',
    field: 'noticeNumber',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Data inregistrare',
    field: 'registrationDate',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Data expeditie',
    field: 'expeditionDate',
    align: 'left',
    type: 'string'
  },
  {
    title: '',
    field: 'truckTypePrint',
    align: 'left',
    type: 'string',
    width: '100px',
    render: row => {
      return row.noticeNumber && row.noticeSeries ? (
        <div onClick={() => printNotice(row.id)}>
          <PrintOutlined style={{ width: '18px', color: '#0970E6', cursor: 'pointer' }} />
        </div>
      ) : (
        <div />
      )
    }
  }
]

const currentDate = getCurrentDate()

export const getFilters = ({
 shopOptions,
 parentSocietyOptions
}) => [
  {
    name: 'shopCode',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza magazin"
        options={shopOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Selecteaza magazin'
  },
  {
    name: 'supplierCode',
    value: '',
    filter: <Input variant="outlined" label="Cod furnizor" type="number" />,
    type: 'number',
    label: 'Cod furnizor'
  },
  {
    name: 'supplierName',
    filter: <Input variant="outlined" label="Furnizor" type="text" />,
    type: 'text',
    label: 'Furnizor'
  },
  {
    name: 'parentSociety',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza Societate"
        options={parentSocietyOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Selecteaza Societate'
  },
  {
    name: 'startExpeditionDate',
    value: currentDate,
    filter: (
      <DatePicker
        label="Selecteaza data de la"
        variant="outlined"
        value={currentDate}
        onChange={() => {}}
        required
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data de la'
  },
  {
    name: 'endExpeditionDate',
    value: currentDate,
    filter: (
      <DatePicker
        label="Selecteaza data pana la"
        variant="outlined"
        value={currentDate}
        onChange={() => {}}
        required
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data pana la'
  }
]
